import { render, staticRenderFns } from "./CadastroReserva.vue?vue&type=template&id=011901b4&scoped=true&class=template&"
import script from "./CadastroReserva.vue?vue&type=script&lang=js&"
export * from "./CadastroReserva.vue?vue&type=script&lang=js&"
import style0 from "./CadastroReserva.vue?vue&type=style&index=0&id=011901b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011901b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
